import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { closeCollapsible, isNullOrEmpty, openCollapsible, translate } from '../../../utils/util';
import { onRowChange, onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { Breadcrumbs, Button, Collapsible, Input, ScannerCode, SelectPrintType, SelectResource } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import SearchMVIList from './SearchMVIList';
import TruckKanbanService from '../../../services/TruckKanbanService';
import ListUI from '../../../components/UI/ListUI';
import ConfirmModalUI from '../../../components/UI/ConfirmModalUI';
import { ENUMS } from '../../../utils/constants';
import useStateWithPromise from '../../../utils/useEffectUpdate';

const SearchMVI = (props) => {
    const [labels, setLabels] = useStateWithPromise([]);
    const [noPrint, setNoPrint] = useState(false);
    const [params, setparams] = useState({
        print: "L",
        resourceId: props.user.resource || '',
        qrCode: '',
    });
    const [messageModal, setMessageModal] = useState({ open: false, messages: [] });
    const [mvi, setMvi] = useState(props.location?.state?.mvi || '');

    useEffect(() => {
        props.resetPhysicalConfirmation();
        if (!isNullOrEmpty(props.location?.state?.mvi)) {
            onSearch()
        }
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, params, setparams)
    };

    const onSearch = () => {
        if (!isNullOrEmpty(mvi)) {
            props.getLabels({
                mvi: mvi,
                truckKanban: true,
                changeLocation: false,
                shed: props.sheds.find((i) => i.id === props.user.shed)?.code
            }, (response) => {
                closeCollapsible("mviLocation");
                setLabels(response);
            });
        }
    }

    const sendLocationMassive = () => {

        if (validateInputsRequired("formSearch")) {
            let arrayLocation = [];
            labels.forEach((label) => {
                let existItem = arrayLocation.find(a => a.barCode === label.masterCim);
                arrayLocation.push({
                    idLabel: label.id,
                    idPallet: label.idPallet,
                    barCode: label.checked ? label.masterCim : (!isNullOrEmpty(label.cimPallet) ? label.cimPallet : label.cim),
                    resource: setResource(),
                    location: "%",
                    mdr: label.sendChangeMdr === true && isNullOrEmpty(label.mdrNew) ? label.mdr : label.mdrNew,
                    print: params.print,
                    printer: noPrint ? null : props.user?.printer,
                    truckKanban: true,
                    send: (isNullOrEmpty(existItem) || isNullOrEmpty(label.masterCim)) ? true : false,
                    cimQuantity: label.checked ? 0 : !isNullOrEmpty(label.qmeQuantity) && label.qmeQuantity > 0 ? label.qmeQuantity : label.cimQuantity
                });

            })

            props.changeLocation(arrayLocation, (response) => {
                if (response && response.filter(f => f.erro).length > 0) {
                    messageModal.open = true;
                    messageModal.messages = response
                    return setMessageModal({ ...messageModal });
                } else {
                    var cim = document.getElementById("qrCode");
                    if (cim) {
                        cim.value = ""
                    }
                    onSearch()
                }
            });
        } else {
            openCollapsible("mviLocation");
        }
    };

    const sendLocationItem = (label) => {
        if (validateInputsRequired("formSearch")) {
            let itemSend = [];
            if (label.checked && !isNullOrEmpty(label.masterCim)) {
                var arrayMasterCim = labels.filter(f => f.checked && f.masterCim === label.masterCim);

                for (let index = 0; index < arrayMasterCim.length; index += 1) {
                    const element = arrayMasterCim[index];
                    itemSend.push({
                        idLabel: element.id,
                        idPallet: element.idPallet,
                        barCode: element.checked ? element.masterCim : (!isNullOrEmpty(element.cimPallet) ? element.cimPallet : element.cim),
                        resource: setResource(),
                        location: "%",
                        mdr: element.sendChangeMdr && isNullOrEmpty(element.mdrNew) ? element.mdr : element.mdrNew,
                        print: "L",
                        send: index === 0,
                        truckKanban: true,
                        printer: noPrint ? null : props.user?.printer,
                        cimQuantity: element.checked ? 0 : !isNullOrEmpty(element.qmeQuantity) && element.qmeQuantity > 0 ? element.qmeQuantity : element.cimQuantity
                    })
                }
            } else {
                itemSend.push({
                    idLabel: label.id,
                    idPallet: label.idPallet,
                    barCode: label.checked ? label.masterCim : (!isNullOrEmpty(label.cimPallet) ? label.cimPallet : label.cim),
                    resource: setResource(),
                    location: "%",
                    mdr: label.sendChangeMdr === true && isNullOrEmpty(label.mdrNew) ? label.mdr : label.mdrNew,
                    print: "L",
                    send: true,
                    truckKanban: true,
                    printer: noPrint ? null : props.user?.printer,
                    cimQuantity: label.checked ? 0 : !isNullOrEmpty(label.qmeQuantity) && label.qmeQuantity > 0 ? label.qmeQuantity : label.cimQuantity
                })
            }

            props.changeLocation(itemSend, (response) => {
                if (response && response.filter(f => f.erro)) {
                    messageModal.open = true;
                    messageModal.messages = response
                    setMessageModal({ ...messageModal });
                } else {
                    var cim = document.getElementById("qrCode");
                    if (cim) {
                        cim.value = ""
                    }
                    onSearch()
                }
            });
        } else {
            openCollapsible("mviLocation");
        }
    };

    const setResource = () => {
        return props.user?.resourceObj?.name;
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    }


    const onCheckDontPrint = () => {
        setNoPrint(noPrint ? false : true);
    }

    const onCheckItem = (item) => {
        var itemsMasterCim = labels.filter(l => l.masterCim === item.masterCim);
        itemsMasterCim.forEach(element => {
            if (element.checked) {
                element.checked = false;
            }
            else {
                element.checked = true;
            }
        });
        setLabels([...labels]);
    }

    const onFilterCim = (value) => {
        if (!isNullOrEmpty(value) && value.length > 5) {
            var cim = "";
            var pallet = "";
            var qrCode = "";
            if (value.split('-').length > 1) {
                pallet = value.split('-')[0];
                cim = value.split('-')[1]
            } else {
                qrCode = value;
            }

            params.qrCode = value;
            setparams({ ...params });

            if (!isNullOrEmpty(mvi)) {
                props.getLabels({
                    qrCode: qrCode,
                    pallet: pallet,
                    cim: cim,
                    mvi: mvi,
                    truckKanban: true,
                    changeLocation: false,
                    shed: props.sheds.find((i) => i.id === props.user.shed)?.code
                }, (response) => {
                    if (response && response.length > 0) {
                        closeCollapsible("mviLocation");
                    }
                    setLabels(response);
                });
            }
        }

        if (isNullOrEmpty(value) && !isNullOrEmpty(params.qrCode)) {
            onSearch();
            params.qrCode = value;
            setparams({ ...params });
        }
    }

    const redirectDropMaterial = (item) => {
        let filterDropMaterial = {
            partNumber: item.partNumberCode || '',
            area: '',
            cim: item.cim || '',
            print: 'C',
            resourceId: props.user.resource || '',
            qtd: item.quantity || '',
            justification: '',
            masterCim: 'N'
        };

        props.history.push({
            state: {
                barcode: true,
                dataParams: filterDropMaterial,
                disable: true
            },
            pathname: `../../warehousemanagement/stock/drop`,
        });


    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrderItem" title={{ icon: "mdi mdi-truck-delivery-outline", label: translate('search-mvi', 'physical-confirmation') }} />
            <div className="container" style={{ width: '98%', marginTop: '40px' }}>
                <Collapsible
                    simple="true"
                    id="mviLocation"
                    header={`Filtros MVI ${mvi}`}
                    body={<div className="row no-padding" id="formSearch">
                        <div className="input-field no-padding col s10">
                            <Input
                                id="mvi"
                                name="mvi"
                                placeholder={translate('mvi', 'physical-confirmation')}
                                type="text"
                                value={mvi}
                                onChange={(evt) => setMvi(evt.target.value)}
                                onKeyDown={handleOnKeyDown}
                            />
                            <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={(value) => setMvi(value)} />
                        </div>
                        <div className="col s1" style={{ paddingTop: '10px' }}>
                            <button
                                className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                type="button"
                                onClick={onSearch}
                            >
                                <i className="Small material-icons">search</i>
                            </button>
                        </div>
                        <div className="input-field no-padding col s6">
                            <SelectPrintType
                                required
                                onChange={onChange}
                                value={params.print || ""}
                            />
                        </div>
                        <div className="input-field no-padding col s5">
                            <SelectResource
                                name="resourceId"
                                id="resourceId"
                                required={params.print === ENUMS.ePrintTypes.Logistics.value || params.print === ENUMS.ePrintTypes.Click.value}
                                value={params.resourceId}
                                onChange={onChange} />
                        </div>
                    </div>
                    }
                />
                <div className="container-fluid" style={{ marginTop: '5px', paddingBlockEnd: '50px' }}>
                    {
                        (labels.length > 0 || !isNullOrEmpty(mvi)) &&
                        <div className='row'>
                            <div className="input-field no-padding col s5">
                                <Input
                                    id="qrCode"
                                    name="qrCode"
                                    placeholder="CIM"
                                    type="text"
                                    onChange={(evt) => onFilterCim(evt.target.value)}
                                />
                                <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={(value) => onFilterCim(value)} />
                            </div>
                            <div className="input-field no-padding col s5">
                                <span
                                    className="title sixth-text-color right"
                                    style={{ position: 'absolute', marginTop: '5px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                >
                                    <Input
                                        type="checkbox"
                                        onChange={() => onCheckDontPrint()}
                                        id="noPrint"
                                        name="noPrint"
                                        label="Não Imprimir"
                                        checked={noPrint}
                                    />
                                </span>
                            </div>
                        </div>
                    }

                    <ListUI
                        data={
                            labels.map((item, index) => {
                                return (
                                    <SearchMVIList
                                        sendLocationItem={(label) => sendLocationItem(label)}
                                        createConfirmation={(item, mdr) => redirectDropMaterial(item)}
                                        onCheckItem={(label) => onCheckItem(label)}
                                        index={index}
                                        onChange={(evt) => {
                                            onRowChange(evt, labels, setLabels)
                                        }}
                                        item={item}
                                    />
                                );
                            })
                        }
                    />
                </div>
                {
                    labels.length > 0 &&
                    <div className="row" style={{ marginBottom: '5px' }}>
                        <div className="col s12 lefth">
                            <Button onClick={() => sendLocationMassive()} full="true" text={translate('general:change-location-massive')} />
                        </div>
                    </div>
                }
            </div>
            <ConfirmModalUI
                open={messageModal.open}
                id="messageModalErro"
                data={{
                    title: translate('validations:attention'),
                    message: <>
                        <div className="input-field no-padding col s12">
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                {
                                    messageModal.messages.map((message, index) => {
                                        return (
                                            <span key={index} className="title col s12" style={{ fontSize: '1rem', color: message.erro ? 'red' : 'green' }}>
                                                {message.cim} - {message.message}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </>
                }}
                showCancel={false}
                onClose={() => {
                    var clearCim = messageModal.messages.filter(f => !f.erro).length === messageModal.messages.length;
                    messageModal.open = false;
                    messageModal.messages = [];
                    setMessageModal({ ...messageModal });
                    setLabels([]).then(() => {
                        var cim = document.getElementById("qrCode");
                        if (cim && clearCim) {
                            cim.value = ""
                        }
                        onSearch()
                    })
                }}
                btnConfirm={translate('close', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        filter: state.physicalConfirmationReducer.filter,
        mvis: state.physicalConfirmationReducer.mvis,
        sheds: state.configReducer.sheds
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLabels: (filter, callback) => {
            dispatch(TruckKanbanService.getLabels(filter, callback));
        },
        resetPhysicalConfirmation: () => {
            dispatch(PhysicalConfirmationService.resetPhisicalConfirmation());
        },
        changeLocation: (data, callback) => {
            dispatch(PhysicalConfirmationService.changeLocation(data, callback));
        },
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchMVI));
